import { TempStat } from "../../../utils/api-objects/TempStat";
import { SurveyType } from "../../../utils/Enums";

export const getLoginSuccessCount = (stats: TempStat[] = []) => {
    return stats.find(stat => stat.event_type === "login_success")?.counter || 0;
};

export const getLoginFailedCount = (stats: TempStat[] = []) => {
    return stats
        .filter(stat => stat.event_type.startsWith("login_failed"))
        .reduce((sum, stat) => sum + stat.counter, 0);
};

export const getCheckupSurveyCount = (surveysCompleted: any[] = []) => {
    return surveysCompleted.filter(s => s.survey_type === SurveyType.CheckupSurvey).length;
};